import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}api/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    postPaymentSession: builder.mutation<
      {
        session: string;
      },
      {
        url: string;
        branch_id: string;
      }
    >({
      query: (body) => ({
        url: "validate-apple-session/",
        method: "POST",
        body,
      }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          const res = await queryFulfilled;
          if (res.meta?.response?.status === 201) {
            toast.success("Payment session validated successfully");
          }
        } catch (error) {
          toast.error("Failed to validate payment session");
          console.error(error);
        }
      },
    }),
  }),
});

export const { usePostPaymentSessionMutation } = paymentApi;
